import z from "zod";

import { sizeAttributeSchema } from "@frontend/bridge/sizeSchema";
import { SIZES } from "@frontend/styles/constants";

import { DRAWER_BORDERS } from "./constants";

export const drawerSwipeDirectionSchema = z.enum([
  "up",
  "down",
  "left",
  "right",
]);

export const drawerDataSchema = z.object({
  title: z.string().optional(),
  size: sizeAttributeSchema(SIZES).optional(),
  border: z.enum(DRAWER_BORDERS).optional(),
  swipeDirection: drawerSwipeDirectionSchema.optional(),
  modal: z
    .enum(["true", "false", "trap-focus"])
    .optional()
    .transform((value) =>
      value === undefined
        ? undefined
        : value === "trap-focus"
          ? ("trap-focus" as const)
          : value === "true",
    ),
  disablePointerDismissal: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type DrawerDataProps = z.infer<typeof drawerDataSchema>;

export const drawerFooterDataSchema = z.object({});

export type DrawerFooterDataProps = z.infer<typeof drawerFooterDataSchema>;
